
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'outerContainer': {'display': `flex`,'alignItems': `center`,'justifyContent': `center`,'flexDirection': `column`,'padding': `2rem 0`,},'linkContainer': {'width': `85%`,'paddingBottom': `1.5rem`,},'messageContainer': {'width': `85%`,'height': `auto`,'backgroundColor': `#ffffff`,'boxShadow': `0 1px 2px 0 rgba(0, 0, 0, 0.3)`,'borderRadius': `0`,},'title': {'textTransform': `uppercase`,'fontWeight': `400`,'fontSize': `1rem`,'textAlign': `center`,'margin': `1.5rem 0 0.5rem 0`,'padding': `0 1.5rem`,},'dateTime': {'color': `#9d2a21`,'fontSize': `0.75rem`,'textAlign': `center`,'padding': `0 1.5rem`,'margin': `0 0 1.25rem 0`,},'messageBody': {'padding': `0 1.5rem 1rem 1.5rem`,'fontSize': `0.875rem`,'textAlign': `justify`,},
        
      };
    };
  